import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  ancpForm: {
    color: theme.palette.text.primary,
    marginBottom: 16,
    padding: 16,
    borderRadius: 8,
    backgroundColor: '#FFF',
    boxShadow: '0 4px 5px #0000001A',


    [theme.breakpoints.up('md')]: {
      flexWrap: 'wrap',
      display: 'flex',
      '& div:nth-child(1)': {
        width: 'calc(50% - 16px)',
        marginRight: 16,
      },
      '& div:nth-child(2)': {
        width: '50%',
      },
      '& div:nth-child(3)': {
        width: 'calc(25% - 16px)',
        marginRight: 16,

      },
      '& div:nth-child(4)': {
        width: 'calc(25% - 16px)',
        marginRight: 16,
      },
    },
  },

  reportsDivider: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'unset',
      width: '25%',
    },
  },

  ancpButtonContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      '& img': {
        width: 22,
        marginRight: 8,
      },
      [theme.breakpoints.up('sm')]: {
        width: 148
      },
    },
  },
  ancpButtonImportContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      '& img': {
        width: 22,
        marginRight: 8,
        background: '#fff',
        color: '#fff'
      },
      [theme.breakpoints.up('sm')]: {
        width: 148
      },
    },
  },
}))
